import * as dd from 'dingtalk-jsapi'
import { getThirdInfo, loginDingtalk } from './service'
import { getRedirectURI } from '../../../helpers/util'
import queryString from 'querystring'
import { redirectTo } from '../../../helpers/view'
import { querySystemInfo } from '../../../services/common'

export default function (type) {
  return new Promise(async (resolve, reject) => {
    const res = await querySystemInfo()
    if (res.errorCode !== 200) return
    const info = await getThirdInfo(res.data.id)
    const { success, data } = info
    switch (type) {
      case 'dingtalk':
        if (success) {
          const dingtalkInfo = data.find((_) => _.type === 0)
          if (!dingtalkInfo) {
            resolve({ success: false })
            return
          }
          // 2. 通过corpId 去拿到code
          dd.ready(async function () {
            const { code } = await getCodeByCorpId(dingtalkInfo.config.corpId)
            const params = {
              code,
              loginAppId: dingtalkInfo.config.loginAppId,
              corpId: dingtalkInfo.config.corpId,
              // 此处对应PC端钉钉工作台登录方式，但是和H5登录流程一样，用的是授权链接而非二维码扫描，所以state用h5
              state: 'dingtalk_h5'
            }
            loginDingtalk(params).then((res) => {
              redirectTo({
                pathname: '/login',
                state: {
                  is3rdParty: true,
                  res
                }
              })
              resolve({ success: true })
            })
          })
        }
        break

      case 'wechat':
        if (success) {
          const wechatInfo = data.find((_) => _.type === 1)
          localStorage.setItem('thirdInfo', JSON.stringify(wechatInfo))

          if (!wechatInfo) {
            resolve({ success: false })
            return
          }
          // console.log(wechatInfo, 'wechatInfo')
          const wechat_url =
            // eslint-disable-next-line no-restricted-globals
            'ksmo.kpmg.com.cn' === window.location.host
              ? 'https://open.weixin.qq.com/connect/oauth2/authorize'
              : 'https://uatoauth-bridge.kpmg.com.cn:9090/connect/oauth2/authorize'
          const wechat_search = {
            appid: wechatInfo.config.corpId,
            agentid: wechatInfo.config.appAgentId,
            response_type: 'code',
            scope: 'snsapi_base',
            redirect_uri: getRedirectURI(),
            state: `wechat_pc`
          }
          let href = `${wechat_url}?${queryString.stringify(wechat_search)}#wechat_redirect`
          window.location.href = href
          resolve({ success: true })
        }
        break
      default:
        resolve({ success: false })
        break
    }
  })
}

function getCodeByCorpId(corpId) {
  return new Promise((resolve, reject) => {
    dd.runtime.permission.requestAuthCode({
      corpId,
      onSuccess: function (result) {
        resolve(result)
      },
      onFail: function (err) {
        reject(err)
      }
    })
  })
}
